// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22jwE","badges":"styles_badges__2FQvm"};